module.exports = __webpack_public_path__ + "img/logo.2a3c03b7.png";